import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

function Settings() {
  const { user } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (newPassword.length < 4) {
      setMessage({ type: 'error', text: 'Le mot de passe doit contenir au moins 4 caractères' });
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage({ type: 'error', text: 'Les mots de passe ne correspondent pas' });
      return;
    }

    setLoading(true);
    const result = await api.changePassword(oldPassword, newPassword);
    setLoading(false);

    if (result && result.success) {
      setMessage({ type: 'success', text: 'Mot de passe modifié avec succès ✓' });
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } else {
      setMessage({ type: 'error', text: result?.error || 'Erreur lors du changement' });
    }
  };

  return (
    <div className="animate-in">
      {/* Profile Info */}
      <div style={{
        background: '#1a1a1a', borderRadius: '16px', padding: '20px',
        marginBottom: '16px', border: '1px solid #333', textAlign: 'center'
      }}>
        <div style={{ fontSize: '40px', marginBottom: '8px' }}>👤</div>
        <div style={{ fontWeight: 700, fontSize: '18px' }}>{user?.name}</div>
        <div style={{ fontSize: '13px', color: '#888', marginTop: '4px' }}>{user?.phone}</div>
        <div style={{
          display: 'inline-block', marginTop: '8px',
          background: user?.role === 'admin' ? '#92400E' : '#064E3B',
          color: user?.role === 'admin' ? '#FCD34D' : '#6EE7B7',
          padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 600
        }}>
          {user?.role === 'admin' ? '👑 Administrateur' : '🧭 Guide'}
        </div>
      </div>

      {/* Change Password */}
      <div style={{
        background: '#1a1a1a', borderRadius: '16px', padding: '20px',
        border: '1px solid #333'
      }}>
        <div style={{ fontWeight: 600, fontSize: '15px', marginBottom: '16px' }}>
          🔒 Changer le mot de passe
        </div>

        <form onSubmit={handleChangePassword}>
          {user?.role === 'admin' && (
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '6px' }}>
                Ancien mot de passe
              </label>
              <input
                type="password"
                value={oldPassword}
                onChange={e => setOldPassword(e.target.value)}
                placeholder="Mot de passe actuel"
                style={{
                  width: '100%', padding: '12px 14px', background: '#2a2a2a',
                  border: '1px solid #444', borderRadius: '10px', color: 'white',
                  fontSize: '14px', outline: 'none'
                }}
              />
            </div>
          )}

          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '6px' }}>
              Nouveau mot de passe
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Nouveau mot de passe (min 4 caractères)"
              style={{
                width: '100%', padding: '12px 14px', background: '#2a2a2a',
                border: '1px solid #444', borderRadius: '10px', color: 'white',
                fontSize: '14px', outline: 'none'
              }}
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '6px' }}>
              Confirmer le mot de passe
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Répétez le nouveau mot de passe"
              style={{
                width: '100%', padding: '12px 14px', background: '#2a2a2a',
                border: '1px solid #444', borderRadius: '10px', color: 'white',
                fontSize: '14px', outline: 'none'
              }}
            />
          </div>

          {message && (
            <div style={{
              padding: '10px 14px', borderRadius: '10px', marginBottom: '12px', fontSize: '13px',
              background: message.type === 'error' ? '#3B1111' : '#064E3B',
              color: message.type === 'error' ? '#FCA5A5' : '#6EE7B7',
              border: `1px solid ${message.type === 'error' ? '#7F1D1D' : '#065F46'}`
            }}>
              {message.text}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: loading ? '#555' : '#E53E3E',
            color: 'white', border: 'none', borderRadius: '10px',
            fontWeight: 600, fontSize: '14px', cursor: loading ? 'wait' : 'pointer'
          }}>
            {loading ? 'Modification...' : 'Changer le mot de passe'}
          </button>
        </form>
      </div>

      {/* Info */}
      <div style={{
        marginTop: '16px', padding: '14px', background: '#1a1a1a',
        borderRadius: '12px', border: '1px solid #333', fontSize: '12px', color: '#888'
      }}>
        <p>ℹ️ {user?.role === 'admin' 
          ? "En tant qu'admin, vous devez entrer votre ancien mot de passe pour le changer."
          : "En tant que guide, vous pouvez définir un mot de passe pour sécuriser votre compte. La connexion par téléphone restera active."
        }</p>
      </div>
    </div>
  );
}

export default Settings;
